module.exports = __webpack_public_path__ + "img/073-hurricane.808a0d7d.svg";